import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Alert from '@mui/material/Alert';

/*
Affiche un message d'alerte en haut de l'écran si une des couche le demande (variable message)
*/

function MessageAlerte({ mailles, theme1, theme2, theme3 }) {

    const [message, setMessage] = useState("");
    const [afficher, setAfficher] = useState(false);

    useEffect(() => {

        if (typeof theme1 !== "undefined" && theme1.message != null) {
            setMessage(theme1.message);
            afficherMessage();
        }
        if (theme2 != null && theme2.message != null && message ==="") {
            setMessage(theme2.message);
            afficherMessage();
        }
        else if (typeof theme3 !== "undefined" && theme3.message != null && message ==="") {
            setMessage(theme3.message);
            afficherMessage();
        }
        // eslint-disable-next-line
    }, [mailles.ol_uid])

    function afficherMessage() {
        setAfficher(true);

        setTimeout(() => {
            setAfficher(false);
            setMessage("");
        }, 2000);
    }


    return <div>
        {afficher ?
            <Alert severity="warning">{message}</Alert>
            :
            null
        }
    </div>

}
function mapStateToProps(state) {
    return {
        mailles: state.maille,
        theme1: state.theme1,
        theme2: state.theme2,
        theme3: state.theme3,
    }
}


export default connect(mapStateToProps,)(MessageAlerte);
